import { memo } from 'react';
import { useSegmentTransition } from '../../hooks/useSegmentTransition';
import { Segment } from '@/player-config/src/types/RemotionPlayerConfigTypes/Segment/Segment';
import Icon from '@/components/atoms/Icon';
import TooltipV2 from '@/components/TooltipV2';

interface SegmentTransitionButtonProps {
  previousSegment?: Segment;
  nextSegment?: Segment;
  isTransitionApplied: boolean;
}

function SegmentTransitionButton({ previousSegment, nextSegment, isTransitionApplied }: SegmentTransitionButtonProps) {
  const { toggleTransition } = useSegmentTransition({
    previousSegment,
    nextSegment,
    isTransitionApplied
  });

  const handleTransitionClick = () => {
    toggleTransition();
  };

  const styleClass =
    'border-2 border-blue-300 bg-blue-100 text-blue-700 transition-colors hover:border-blue-400 hover:bg-blue-200';

  if (!isTransitionApplied) {
    return null;
  }
  const tooltipContent = 'Remove transition';
  const tooltipId = `segment-transition-${previousSegment?.id ?? 'start'}-${nextSegment?.id ?? 'end'}`;

  return (
    <div className="relative h-full w-5 min-w-5 self-stretch">
      <TooltipV2
        tooltipId={tooltipId}
        tooltipContent={tooltipContent}
        noArrow
        place="top"
        offset={20}
        className="z-50"
        tooltipElement={
          <button
            type="button"
            onClick={e => {
              e.stopPropagation();
              handleTransitionClick();
            }}
            onMouseDown={e => {
              e.stopPropagation();
            }}
            className={`absolute left-1/2 top-1/2 z-50 flex size-8 shrink-0 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-lg transition-colors duration-200 ${styleClass}`}
          >
            <Icon name="IconSwitchHorizontal" width={16} height={16} className="shrink-0 text-blue-600" />
          </button>
        }
      />
    </div>
  );
}

export default memo(SegmentTransitionButton);
